import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Types from './types';

const domain = 'NOTIFICATION_COUNTS';

export const {
    action: getNotificationCount,
    success: getNotificationCountSuccess,
    failed: getNotificationCountFailed,
} = createAction(
    `${domain}/GET_NOTIFICATION_COUNT`,
    (payload: {immediate?: boolean} = {}) => payload,
    (response: Types.UpdatesFromREST) => ({response}),
);

export const {action: listenForUpdates} = createAction(`${domain}/LISTEN_FOR_UPDATES`, () => ({}));
